import { useDispatch } from "react-redux";
import { clearFiles, reset, setFiles } from "../../..";

export const useExtractorPdfActions = () => {
  const dispatch = useDispatch();
  return {
    setFiles:   (f: File[])  => dispatch(setFiles(f)),
    clearFiles: ()           => dispatch(clearFiles()),
    reset:      ()           => dispatch(reset()),
  };
};
